interface LogContext {
	[key: string]: unknown;
	error?: unknown;
}

interface Logger {
	error: (message: string, context?: LogContext) => void;
	warn: (message: string, context?: LogContext) => void;
	info: (message: string, context?: LogContext) => void;
	debug: (message: string, context?: LogContext) => void;
}

const NOOP_LOGGER: Logger = {
	error: () => {},
	warn: () => {},
	info: () => {},
	debug: () => {}
};

export interface LeadFlowLogger extends Logger {
	rumAction: (name: string, context?: Record<string, unknown>) => void;
	rumError: (error: unknown, context?: Record<string, unknown>) => void;
	enabled: boolean;
}

export function useLeadFlowLogger(service: string): LeadFlowLogger {
	const flags = useFeatureFlags();
	const enabled = !!flags.ft_lead_flow_logs_frontend;

	if (!enabled) {
		return {
			...NOOP_LOGGER,
			rumAction: () => {},
			rumError: () => {},
			enabled: false
		};
	}

	const logger = useLogger(service);

	const rumAction = (
		name: string,
		context: Record<string, unknown> = {}
	): void => {
		if (import.meta.client) {
			window.DD_RUM?.addAction(name, context);
		}
	};

	const rumError = (
		error: unknown,
		context: Record<string, unknown> = {}
	): void => {
		if (!import.meta.client) return;
		const err =
			error instanceof Error
				? error
				: new Error(typeof error === 'string' ? error : JSON.stringify(error));
		window.DD_RUM?.addError(err, { ...context, feature: 'lead_flow' });
	};

	return {
		...logger,
		rumAction,
		rumError,
		enabled: true
	};
}
